/**
 * EntityCell — avatar + title + sub-lines cell used as the main table column
 * (replaces customer-name / supplier-name / catalogue-name copies).
 *
 *   <EntityCell icon={BookOpen} code="CAT-001" subtitle="Elektronik" title="Katalog A"
 *               onClick={openDetail} />
 *
 * avatar: pass `icon` (lucide component), `image` (url) or `avatar` (node).
 * With `onClick` the cell renders as a button (keyboard-accessible link).
 */
export default function EntityCell({
  icon: Icon,
  image,
  avatar,
  title,
  code,
  subtitle,
  onClick,
  className = '',
}) {
  const Wrapper = onClick ? 'button' : 'div';
  const wrapperProps = onClick ? { type: 'button', onClick } : {};

  return (
    <Wrapper
      className={`entity-cell${onClick ? ' entity-cell--link' : ''} ${className}`.trim()}
      {...wrapperProps}
    >
      {(Icon || image || avatar) && (
        <span className="entity-cell__avatar">
          {avatar ?? (image ? <img src={image} alt="" /> : <Icon size={16} aria-hidden="true" />)}
        </span>
      )}
      <span className="entity-cell__meta">
        {code && <span className="entity-cell__code">{code}</span>}
        {title && <span className="entity-cell__title">{title}</span>}
        {subtitle && <span className="entity-cell__sub">{subtitle}</span>}
      </span>
    </Wrapper>
  );
}
